import clsx from 'clsx'

import stylesMain from 'assets/css/main.module.scss'
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg'
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg'
import { Flex } from 'components/common/flex/Flex'
import { Icon } from 'components/uikit/Icon/Icon'
import { ListItem } from 'components/uikit/ListItem'
import SingleSelect from 'components/uikit/SingleSelect'

import styles from './Pagination.module.scss'

interface Props {
  page: number
  allPages: number
  itemsPerPage: number
  allItems: number
  onSelectPage: (page: number) => void
  onSelectItemsPerPage: (number: number) => void
  disabled?: boolean
}

export const Pagination = ({
  page,
  allPages,
  itemsPerPage,
  allItems,
  onSelectPage,
  onSelectItemsPerPage,
  disabled,
}: Props) => {
  return (
    <div
      style={{ paddingLeft: 14, paddingRight: 14, marginTop: 24, width: '100%' }}
      className={clsx({ [styles.disabled]: disabled })}
    >
      <Flex align="center" justify="between">
        <Flex gap={6} align="center">
          <div style={{ color: '#4C4C4C' }} className={stylesMain.SBody}>
            Items per page:
          </div>
          <SingleSelect
            disabled={disabled}
            size="s"
            onChange={e => {
              onSelectItemsPerPage(e.detail.value)
            }}
            value={itemsPerPage}
          >
            <ListItem value={10}>
              <p slot="label">10</p>
            </ListItem>
            <ListItem value={20}>
              <p slot="label">20</p>
            </ListItem>
            <ListItem value={50}>
              <p slot="label">50</p>
            </ListItem>
            <ListItem value={100}>
              <p slot="label">100</p>
            </ListItem>
          </SingleSelect>

          <div className={styles.separator} />
          <div
            style={{ color: '#4C4C4C', marginLeft: 16 }}
            className={stylesMain.SBody}
          >{`${(page - 1) * itemsPerPage + 1}-${page * itemsPerPage} of ${allItems} items`}</div>
        </Flex>
        <Flex align="center" gap={8}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (disabled) return
              page !== 1 && onSelectPage(page - 1)
            }}
          >
            <Icon icon={ChevronLeft} color="#A5A5A5" />
          </div>
          <div className={clsx(styles.currentPage, stylesMain.blackPMobile)}>{page}</div>
          <div className={styles.separator} />
          <div className={clsx(styles.allPages, stylesMain.blackPMobile)}>{allPages}</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (disabled) return
              if (page !== allPages) {
                onSelectPage(page + 1)
              }
            }}
          >
            <Icon icon={ChevronRight} color="#8B919A" />
          </div>
        </Flex>
      </Flex>
    </div>
  )
}
